import { createContext, useContext, useState } from 'react';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('calliope_user')); } catch { return null; }
  });

  function login(data) {
    localStorage.setItem('calliope_token', data.access_token);
    localStorage.setItem('calliope_user', JSON.stringify({ id: data.user_id, name: data.name, plan: data.plan }));
    setUser({ id: data.user_id, name: data.name, plan: data.plan });
  }

  function logout() {
    localStorage.removeItem('calliope_token');
    localStorage.removeItem('calliope_user');
    setUser(null);
  }

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
